import './gokart.css'
import '../projectscontent.css'

import { GlowingText2em } from "../../../../components/glowingtextcomponet/glowingtext2em.js";
import { GlowingText1em } from "../../../../components/glowingtextcomponet/glowingtext1em.js";
import { Gallery } from "../../../../components/gallery/gallery.js";
import { TypingText } from "../../../../components/glowingtextcomponet/typingtext.js";

import gritzrconiaflapdisc from "./toolsimages/80gritzrconiaflapdisc.png";
import anglegrinder from "./toolsimages/anglegrinder.png";
import anglegrinderwirebrush from "./toolsimages/anglegrinderwirebrush.png";
import antispatterspray from "./toolsimages/antispatterspray.png";
import benchvise from "./toolsimages/benchvise.png";
import caliper from "./toolsimages/caliper.png";
import cclamp from "./toolsimages/cclamp.png";
import cuttingdisc from "./toolsimages/cuttingdisc.png";
import drill from "./toolsimages/drill.png";
import drillbits from "./toolsimages/drillbits.png";
import gaslessMIGweldingmachine from "./toolsimages/gaslessMIGweldingmachine.png";
import graphitegrease from "./toolsimages/graphitegrease.png";
import grindingdisc from "./toolsimages/grindingdisc.png";
import lockingpliers from "./toolsimages/lockingpliers.png";
import magneticsquare from "./toolsimages/magneticsquare.png";
import measuringtape from "./toolsimages/measurngtape.png";
import MIGwirespool from "./toolsimages/MIGwirespool.png";
import prime from "./toolsimages/prime.png";
import rotaryburr from "./toolsimages/rotaryburr.png";
import stepdrill from "./toolsimages/stepdrill.png";
import toolkit from "./toolsimages/toolkit.png";
import tubebender from "./toolsimages/tubebender.png";
import whiteblackpaint from "./toolsimages/whiteblackpaint.png";
import wirebrush from "./toolsimages/wirebrush.png";

import earmuffs from "./ppeimages/earmuffs.png";
import safityglasses from "./ppeimages/safityglasses.png";
import weldinggloves from "./ppeimages/weldinggloves.png";
import weldinghelmet from "./ppeimages/weldinghelmet.png";

// Braking System
import brakediscandbrakedischub from "./buildingimages/brakingsystemimages/brakingsystemitemimages/brakediscandbrakedischub.png";
import brakehose from "./buildingimages/brakingsystemimages/brakingsystemitemimages/brakehose.png";
import cablehousing_brake from "./buildingimages/brakingsystemimages/brakingsystemitemimages/cablehousing.png";
import dot4brakefluid from "./buildingimages/brakingsystemimages/brakingsystemitemimages/dot4brakefluid.png";
import mastercylinder from "./buildingimages/brakingsystemimages/brakingsystemitemimages/mastercylinder.png";
import pedals_brake from "./buildingimages/brakingsystemimages/brakingsystemitemimages/pedals.png";
import returnspring_brake from "./buildingimages/brakingsystemimages/brakingsystemitemimages/returnspring.png";
import steelbrakeandthrottlecable_brake from "./buildingimages/brakingsystemimages/brakingsystemitemimages/steelbrakeandthrottlecable.png";
import titan150brakecalipers from "./buildingimages/brakingsystemimages/brakingsystemitemimages/titan150brakecalipers.png";

// Braking system build (caliper mount, brake, master cylinder)
import bkcalipertemplate1 from './buildingimages/brakingsystemimages/brakebuildimages/calipertemplate1.png';
import bkcalipertemplate2 from './buildingimages/brakingsystemimages/brakebuildimages/calipertemplate2.png';
import bkcalipertemplate3 from './buildingimages/brakingsystemimages/brakebuildimages/calipertemplate3.png';
import bkcuttingplate from './buildingimages/brakingsystemimages/brakebuildimages/cuttingplatebymold.png';
import bkplatecut from './buildingimages/brakingsystemimages/brakebuildimages/platecutforcaliper.png';
import bksandingsupport from './buildingimages/brakingsystemimages/brakebuildimages/sandingbrakesupportplate.png';
import bkdisccaliper from './buildingimages/brakingsystemimages/brakebuildimages/brakediscandcaliper.png';
import bkassembled from './buildingimages/brakingsystemimages/brakebuildimages/supportandbrakeassembled.png';
import bkreadytoweld from './buildingimages/brakingsystemimages/brakebuildimages/brakesystemreadytoweld.png';
import bkweldingsupport from './buildingimages/brakingsystemimages/brakebuildimages/weldingbrakesupport.png';
import bkadjusting from './buildingimages/brakingsystemimages/brakebuildimages/adjustingbrakecaliper.png';
import bkonchassis from './buildingimages/brakingsystemimages/brakebuildimages/brakesystemonchassis.png';
import bkmclever from './buildingimages/brakingsystemimages/brakebuildimages/mastercylinderleverdesign.png';
import bkvidfinal from './buildingimages/brakingsystemimages/brakebuildimages/brakefinalresult.mp4';
import bkvidpad from './buildingimages/brakingsystemimages/brakebuildimages/adjustingpadcontact.mp4';
import bkvidmcmount from './buildingimages/brakingsystemimages/brakebuildimages/mastercylindermounted.mp4';
import bkvidmctest from './buildingimages/brakingsystemimages/brakebuildimages/testingbrakepedalcylinder.mp4';

// Steering build (knuckle, column, supports)
import stdesigncp1 from './buildingimages/steeringimages/steeringbuildimages/designingcentralpart1.png';
import stdesigncp2 from './buildingimages/steeringimages/steeringbuildimages/designingcentralpart2.png';
import stdesigncp3 from './buildingimages/steeringimages/steeringbuildimages/designingcentralpart3.png';
import stmachiningcp from './buildingimages/steeringimages/steeringbuildimages/machiningcentralpart.png';
import stcentralpart from './buildingimages/steeringimages/steeringbuildimages/centralpart.png';
import stcentralknuckle from './buildingimages/steeringimages/steeringbuildimages/centralknucklepart.png';
import strearplatestart from './buildingimages/steeringimages/steeringbuildimages/rearplatestart.png';
import strearplate1 from './buildingimages/steeringimages/steeringbuildimages/rearplate1.png';
import strearplate2 from './buildingimages/steeringimages/steeringbuildimages/rearplate2.png';
import stknucklespacers from './buildingimages/steeringimages/steeringbuildimages/knucklespacers.png';
import stknuckleassembled from './buildingimages/steeringimages/steeringbuildimages/knuckleassembled.png';
import stknucklefinal from './buildingimages/steeringimages/steeringbuildimages/knucklefinalresult.png';
import staxlebeforeafter from './buildingimages/steeringimages/steeringbuildimages/axlebeforeafter.png';
import staxlemachining from './buildingimages/steeringimages/steeringbuildimages/machiningaxle.mp4';
import staxlefinal from './buildingimages/steeringimages/steeringbuildimages/axlefinalresult.png';
import stdesignbarsup1 from './buildingimages/steeringimages/steeringbuildimages/designingbarsupport1.png';
import stdesignbarsup2 from './buildingimages/steeringimages/steeringbuildimages/designingbarsupport2.png';
import stbarsupdone from './buildingimages/steeringimages/steeringbuildimages/barsupportsdone.png';
import stdesigncolsup from './buildingimages/steeringimages/steeringbuildimages/designingcolumnbearingsupport.png';
import stcheckcolheight from './buildingimages/steeringimages/steeringbuildimages/checkingcolumnbearingheight.png';
import stchecksupheight from './buildingimages/steeringimages/steeringbuildimages/checkingbearingsupportheight.png';
import stfinalizingcolumn from './buildingimages/steeringimages/steeringbuildimages/finalizingcolumn.png';
import ststeeringfinished from './buildingimages/steeringimages/steeringbuildimages/steeringfinished.png';
import stweldingcolsup from './buildingimages/steeringimages/steeringbuildimages/weldingcolumnsupport.png';
import stcolsupfinished from './buildingimages/steeringimages/steeringbuildimages/columnsupportfinished.png';
import stvidknuckle from './buildingimages/steeringimages/steeringbuildimages/knuckleonsupport.mp4';
import stvidsystem from './buildingimages/steeringimages/steeringbuildimages/steeringsystemfinished.mp4';
import stvidtank from './buildingimages/steeringimages/steeringbuildimages/testingsteeringwithtank.mp4';


// Chassis
import carbonsteelplate2mm from './buildingimages/chassisimages/chassisitemimages/2mmcarbonsteelplate.png';
import tuboacocarbonomeiopol2mm from './buildingimages/chassisimages/chassisitemimages/tuboacocarbonomeiopol2mm.png';
import basicframeresult from './chassibuildingimages/basicframe/basicframeresult.png';
import crossbar from './chassibuildingimages/basicframe/crossbar.png';
import crossbaridea from './chassibuildingimages/basicframe/crossbaridea.png';
import externalsidebar from './chassibuildingimages/basicframe/externalsidebar.png';
import fishmouthjoint1 from './chassibuildingimages/basicframe/fishmouthjoint1.png';
import fishmouthjoint2 from './chassibuildingimages/basicframe/fishmouthjoint2.png';
import fishmouthvideo from './chassibuildingimages/basicframe/makingfishmouth.mp4';
import frontalpiececonnector from './chassibuildingimages/basicframe/frontalpiececonnector.png';
import frontalpiececonnectorresult from './chassibuildingimages/basicframe/frontalpiececonnectorresult.png';
import frontalpiecefixed from './chassibuildingimages/basicframe/frontalpiecefixed.png';
import frontparttemplate from './chassibuildingimages/basicframe/frontparttemplate.png';
import internalcrossbaridea from './chassibuildingimages/basicframe/internalcrossbaridea.png';
import internalcrossbarresult from './chassibuildingimages/basicframe/internalcrossbarresult.png';
import internalsidebar from './chassibuildingimages/basicframe/internalsidebar.png';
import internalsidebarfishmouthjoint from './chassibuildingimages/basicframe/internalsidebarfishmouthjoint.png';
import internalsidebaridea from './chassibuildingimages/basicframe/internalsidebaridea.png';
import internalsidebarwelded from './chassibuildingimages/basicframe/internalsidebarwelded.png';
import kartspiece from './chassibuildingimages/basicframe/kartspiece.png';
import measuringprotractor from './chassibuildingimages/basicframe/measuringprotractor.png';
import pipeelbowcut from './chassibuildingimages/basicframe/pipeelbowcut.png';
import pipeelbowwelded from './chassibuildingimages/basicframe/pipeelbowwelded.png';
import sideplate from './chassibuildingimages/basicframe/sideplate.png';
import sidebarconnector from './chassibuildingimages/basicframe/sidebarconnector.png';
import sidebarconnectorresult1 from './chassibuildingimages/basicframe/sidebarconnectorresult1.png';
import sidebarconnectorresult2 from './chassibuildingimages/basicframe/sidebarconnectorresult2.png';
import sidebarweldedconnector from './chassibuildingimages/basicframe/sidebarweldedconnector.png';
import weldedconnector from './chassibuildingimages/basicframe/weldedconnector.png';
import woodentemplate1 from './chassibuildingimages/basicframe/woodentemplate1.png';
import woodentemplate2 from './chassibuildingimages/basicframe/woodentemplate2.png';

// Chassis floor (assoalho)
import floormold from './chassibuildingimages/floor/floormold.png';
import floorcad from './chassibuildingimages/floor/floorcad.png';
import bendinthefloor from './chassibuildingimages/floor/bendinthefloor.png';
import floorresult from './chassibuildingimages/floor/floorresult.png';
import weldingfloorsupport from './chassibuildingimages/floor/weldingfloorsupport.png';
import weldingfloorsupportresult from './chassibuildingimages/floor/weldingfloorsupportresult.png';
import floorwithsupport from './chassibuildingimages/floor/floorwithsupport.png';

// Chassis engine mount (motor support)
import enginemountplaning from './chassibuildingimages/enginemount/planingenginesupport.png';
import enginemountpieces from './chassibuildingimages/enginemount/enginesupportpieces.png';
import enginemountstarting from './chassibuildingimages/enginemount/startingplaningenginesupport.png';
import enginemountwelding from './chassibuildingimages/enginemount/weldingmotorsupport.png';

// Chassis seat support (suporte do banco)
import seatsupportstart from './chassibuildingimages/seatsupport/startingbuildingseatsupport.png';
import seatsupportengine from './chassibuildingimages/seatsupport/avoidingenginecontact.png';
import seatsupportwelding from './chassibuildingimages/seatsupport/startingweldingseatsupport.png';
import seatsupportstructure from './chassibuildingimages/seatsupport/completingallstructureseatsupport.png';
import seatsupportfinal from './chassibuildingimages/seatsupport/finalizingseatsupport.png';
import seatsupportresult from './chassibuildingimages/seatsupport/seatfinalresult.png';

// Chassis spindle / steering-knuckle support (suporte da manga de eixo)
import spindlebuild from './chassibuildingimages/spindlesupport/buildingsteeringknucklesupport.png';
import spindlebushings from './chassibuildingimages/spindlesupport/steeringknucklesupportresult.png';
import spindlewelding1 from './chassibuildingimages/spindlesupport/weldingsteeringknucklesupportinthekart1.png';
import spindlewelding2 from './chassibuildingimages/spindlesupport/weldingsteeringknucklesupportinthekart2.png';
import spindlefinal from './chassibuildingimages/spindlesupport/steeringknucklesupportfinalresult.png';

// Completed chassis
import chassiscomplete1 from './chassibuildingimages/chassiscomplete/chassicompleted1.png';
import chassiscomplete2 from './chassibuildingimages/chassiscomplete/chassicompleted2.png';
import chassivideo from './chassibuildingimages/chassiscomplete/chassi4.mp4';

// Painting
import paintprepprime from './paintingimages/preparingforprime.png';
import paintapplyprime from './paintingimages/applyingprime.png';
import paintprepdetails from './paintingimages/preparingforpaitingdetails.png';
import paintchassi from './paintingimages/paintingchassi.png';
import paintchassi2 from './paintingimages/paintingchassi2.png';
import paintedchassi from './paintingimages/paintedchassi1.png';
import paintdetails from './paintingimages/paintingdetails.png';
import paintdetails2 from './paintingimages/paitingdetails2.png';
import paintdetails3 from './paintingimages/paitingdetails3.png';
import paintfinalresult from './paintingimages/paitingfinalresult.png';

// Fuel Tank
import fuelfilter from './buildingimages/fueltankimages/fueltankitemimages/fuelfilter.png';
import fuelhose from './buildingimages/fueltankimages/fueltankitemimages/fuelhose.png';
import vacuumpump from './buildingimages/fueltankimages/fueltankitemimages/vacuumpump.png';
import fueltankmounted from './buildingimages/fueltankimages/fueltankbuildimages/fueltankmounted.png';

// Steering
import bearing_steering from './buildingimages/steeringimages/steeringitemimages/bearing.png';
import rodendsandsteeringrod from './buildingimages/steeringimages/steeringitemimages/rodendsandsteeringrod.png';
import spindle from './buildingimages/steeringimages/steeringitemimages/spindle.png';
import steeringcolumnbearinghousing from './buildingimages/steeringimages/steeringitemimages/steeringcolumnbearinghousing.png';
import steeringwheel from './buildingimages/steeringimages/steeringitemimages/steeringwheel.png';
import steeringwheelhub from './buildingimages/steeringimages/steeringitemimages/steeringwheelhub.png';

// Throttle
import cablehousing_throttle from './buildingimages/throttleimages/throttleitemimages/cablehousing.png';
import pedals_throttle from './buildingimages/throttleimages/throttleitemimages/pedals.png';
import returnspring_throttle from './buildingimages/throttleimages/throttleitemimages/returnspring.png';
import steelbrakeandthrottlecable_throttle from './buildingimages/throttleimages/throttleitemimages/steelbrakeandthrottlecable.png';

// Throttle build process
import throttlepedalssupport from './buildingimages/throttleimages/throttlebuildimages/pedalssupport.png';
import throttlepedals from './buildingimages/throttleimages/throttlebuildimages/pedals.png';

// Transmission
import chain428h120 from './buildingimages/transmissionimages/transmissionitemimages/428hchain120links.png';
import bearinghousings_transmission from './buildingimages/transmissionimages/transmissionitemimages/bearinghousings.png';
import centrifugalclutch from './buildingimages/transmissionimages/transmissionitemimages/centrifugalclutch.png';
import sprocketandsprockethub from './buildingimages/transmissionimages/transmissionitemimages/sprocketandsprockethub.png';
import transmissionshaft30mm1m from './buildingimages/transmissionimages/transmissionitemimages/transmissonshaft30mm1meter.png';
import wheelhub_transmission from './buildingimages/transmissionimages/transmissionitemimages/wheelhub.png';
import transaxleparts from './buildingimages/transmissionimages/transmissionbuildimages/transmissionaxleparts.png';
import transsprocket from './buildingimages/transmissionimages/transmissionbuildimages/sprocketonaxle.png';
import transvid from './buildingimages/transmissionimages/transmissionbuildimages/transmissionaxleinstalled.mp4';

// Engine assembly (parts in engineitemimages; assembly photos/videos in engineassembly)
import engzmax from './assemblyimages/engineitemimages/zmax15hp4strokeengne.png';
import engcarburetor from './assemblyimages/engineitemimages/carburetor.png';
import engairfilter from './assemblyimages/engineitemimages/airfilter.png';
import engexhaust from './assemblyimages/engineitemimages/exhaust.png';
import engintakemanifold from './assemblyimages/engineitemimages/intakemanifold.png';
import engchokecable from './assemblyimages/engineitemimages/chokecable.png';
import engtacho from './assemblyimages/engineitemimages/tachometerhourmeter.png';
import enghosebarb from './assemblyimages/engineitemimages/hosebarb.png';
import engcarb1 from './assemblyimages/engineassembly/carburetorinstalled1.png';
import engcarb2 from './assemblyimages/engineassembly/carburetorinstalled2.png';
import engmanifoldgasket from './assemblyimages/engineassembly/intakemanifoldgasket.png';
import engfuelpump from './assemblyimages/engineassembly/fuelpumpinstalled.png';
import engclutchphoto from './assemblyimages/engineassembly/clutchmounted.png';
import engvidclutch from './assemblyimages/engineassembly/clutchinstalled.mp4';
import engvidexhaust from './assemblyimages/engineassembly/exhaustinstalled.mp4';
import engvidtest from './assemblyimages/engineassembly/enginefactorytest.mp4';

// Final assembly sequence
import faStart from './assemblyimages/finalassembly/startingassembly.png';
import faKnuckles from './assemblyimages/finalassembly/fittingknucklesfloorandpedals.png';
import faEngine from './assemblyimages/finalassembly/installingengineandtransmission.png';
import faSteering from './assemblyimages/finalassembly/installingsteeringandfrontwheels.png';
import faClutch from './assemblyimages/finalassembly/fittingclutchandchain.png';
import faBrakes from './assemblyimages/finalassembly/installingbrakes.png';
import faTankSeat from './assemblyimages/finalassembly/fittingtankandseat.png';
import faComplete from './assemblyimages/finalassembly/kartfullyassembled.png';

// Results (finished go-kart running)
import resulttestrun from './resultsimages/resulttestrun.mp4';
import resultdriving from './resultsimages/resultdriving.mp4';

const GALLERY_IMAGE_STYLE = { width: '600px', height: '600px' };

const toolimages = [
  { file: gritzrconiaflapdisc, description: '80 Grit Zirconia Flap Disc' },
  { file: anglegrinder, description: 'Angle Grinder' },
  { file: anglegrinderwirebrush, description: 'Angle Grinder Wire Brush' },
  { file: antispatterspray, description: 'Anti Spatter Spray' },
  { file: benchvise, description: 'Bench Vise' },
  { file: caliper, description: 'Caliper' },
  { file: cclamp, description: 'C-Clamp' },
  { file: cuttingdisc, description: 'Cutting Disc' },
  { file: drill, description: 'Electric Drill' },
  { file: drillbits, description: 'Drill Bits Set' },
  { file: gaslessMIGweldingmachine, description: 'Gasless MIG Welding Machine' },
  { file: graphitegrease, description: 'Graphite Grease' },
  { file: grindingdisc, description: 'Grinding Disc' },
  { file: lockingpliers, description: 'Locking Pliers' },
  { file: magneticsquare, description: 'Magnetic Welding Square' },
  { file: measuringtape, description: 'Measuring Tape' },
  { file: MIGwirespool, description: 'MIG Welding Wire Spool' },
  { file: prime, description: 'Welding Primer' },
  { file: rotaryburr, description: 'Rotary Burr' },
  { file: stepdrill, description: 'Step Drill Bit' },
  { file: toolkit, description: 'Toolkit' },
  { file: tubebender, description: 'Tube Bender' },
  { file: whiteblackpaint, description: 'White and Black Spray Paint' },
  { file: wirebrush, description: 'Wire Brush' }
];

const ppeimages = [
  { file: safityglasses, description: 'Safety Glasses' },
  { file: earmuffs, description: 'Earmuffs' },
  { file: weldinggloves, description: 'Welding Gloves' },
  { file: weldinghelmet, description: 'Welding Helmet' }
];

const brakingsystemitemimages = [
  { file: brakediscandbrakedischub, description: 'Brake Disc and Brake Disc Hub' },
  { file: brakehose, description: 'Brake Hose' },
  { file: cablehousing_brake, description: 'Cable Housing (Brakes)' },
  { file: dot4brakefluid, description: 'DOT 4 Brake Fluid' },
  { file: mastercylinder, description: 'Master Cylinder' },
  { file: pedals_brake, description: 'Pedals (Brakes)' },
  { file: returnspring_brake, description: 'Return Spring (Brakes)' },
  { file: steelbrakeandthrottlecable_brake, description: 'Steel Brake and Throttle Cable' },
  { file: titan150brakecalipers, description: 'Titan 150 Brake Calipers' }
];

const brakecaliperbuildimages = [
  { file: bkcalipertemplate1, description: 'Taking a template off the Titan 150 caliper to trace its shape onto the plate.' },
  { file: bkcalipertemplate2, description: 'Transferring the caliper profile to the steel plate.' },
  { file: bkcalipertemplate3, description: 'The traced caliper template, ready to be cut.' },
  { file: bkcuttingplate, description: 'Cutting the plate to the caliper shape following the template.' },
  { file: bkplatecut, description: 'The plate cut to match the caliper.' },
  { file: bksandingsupport, description: 'Sanding the brake support plates to finish them.' }
];

const brakemountimages = [
  { file: bkdisccaliper, description: 'The brake disc with the Titan 150 caliper fitted.' },
  { file: bkassembled, description: 'The support and brake assembled together.' },
  { file: bkreadytoweld, description: 'The brake assembly positioned and ready to weld onto the chassis.' },
  { file: bkweldingsupport, description: 'Tacking the brake support to the chassis with the caliper in place.' }
];

const brakeadjustimages = [
  { file: bkadjusting, description: 'Adjusting the caliper so the pads meet the disc squarely.' },
  { file: bkvidpad, description: 'Fine-tuning the pad-to-disc contact point.' },
  { file: bkvidfinal, description: 'The finished rear brake working.' },
  { file: bkonchassis, description: 'The finished brake mounted on the chassis.' }
];

const mastercylinderbuildimages = [
  { file: bkmclever, description: 'Designing the pivoting lever that drives the master-cylinder pushrod.' },
  { file: bkvidmcmount, description: 'The master cylinder mounted on its removable plate.' },
  { file: bkvidmctest, description: 'Testing the brake pedal pulling the master cylinder through the cable.' }
];

const steeringknucklepartimages = [
  { file: stdesigncp1, description: 'Designing the central part of the knuckle in SolidWorks.' },
  { file: stdesigncp2, description: 'CAD detail of the central part — a one-inch tube machined for two bearings.' },
  { file: stdesigncp3, description: 'Another view of the central-part design.' },
  { file: stmachiningcp, description: 'Machining the central part on the lathe.' },
  { file: stcentralpart, description: 'The finished central part, bored 21 mm for the axle stub.' },
  { file: stcentralknuckle, description: 'The central steering-knuckle piece ready to assemble.' }
];

const steeringknucklerearimages = [
  { file: strearplatestart, description: 'Starting the rear plate that anchors the steering bar.' },
  { file: strearplate2, description: 'Rear-plate detail with the steering-bar holes.' },
  { file: strearplate1, description: 'The rear plate cut to the standard profile.' }
];

const steeringknuckleaxleimages = [
  { file: staxlebeforeafter, description: 'The wheel axle stub before and after being turned down on the lathe.' },
  { file: staxlemachining, description: 'Machining the wheel axle stub to fit the central part.' },
  { file: staxlefinal, description: 'The finished wheel axle stub.' }
];

const steeringknuckleassemblyimages = [
  { file: stknuckleassembled, description: 'The three parts TIG-welded together with the bearings fitted.' },
  { file: stknucklefinal, description: 'The finished steering knuckle.' },
  { file: stknucklespacers, description: 'Spacers that position the knuckle on its support during installation.' },
  { file: stvidknuckle, description: 'The finished knuckle pivoting on its support.' }
];

const steeringbarsupportimages = [
  { file: stdesignbarsup1, description: 'Designing the steering-bar support in SolidWorks.' },
  { file: stdesignbarsup2, description: 'CAD detail of the steering-bar support.' },
  { file: stbarsupdone, description: 'The steering-bar supports fabricated.' }
];

const steeringcolumnimages = [
  { file: stdesigncolsup, description: 'Designing the support that carries the column on two bearings.' },
  { file: stcheckcolheight, description: 'Checking the height of the column bearing.' },
  { file: stchecksupheight, description: 'Checking the height of the bearing support.' },
  { file: stfinalizingcolumn, description: 'Finalizing the steering column.' }
];

const steeringcolumnsupportimages = [
  { file: stweldingcolsup, description: 'Welding the column support to the chassis.' },
  { file: stcolsupfinished, description: 'The column support finished.' }
];

const steeringfinishedimages = [
  { file: ststeeringfinished, description: 'The complete steering assembly.' },
  { file: stvidsystem, description: 'The finished steering system.' },
  { file: stvidtank, description: 'Testing the steering with the fuel tank fitted.' }
];

const fueltankbuildimages = [
  { file: fueltankmounted, description: 'The fuel tank mounted under the steering column on welded brackets.' }
];

const transmissionbuildimages = [
  { file: transaxleparts, description: 'The transmission-axle parts laid out: shaft, sprocket, rear brake disc and wheel hubs.' },
  { file: transsprocket, description: 'The sprocket installed on the axle.' },
  { file: transvid, description: 'The complete transmission axle installed on the chassis.' }
];

const enginepartimages = [
  { file: engzmax, description: 'Z-MAX 15 HP single-cylinder 4-stroke engine — the power unit.' },
  { file: engcarburetor, description: 'Carburetor.' },
  { file: engairfilter, description: 'Air filter.' },
  { file: engintakemanifold, description: 'Intake manifold.' },
  { file: engexhaust, description: 'Exhaust.' },
  { file: engchokecable, description: 'Choke cable.' },
  { file: enghosebarb, description: 'Fuel hose barb.' },
  { file: engtacho, description: 'Tachometer / hour meter.' }
];

const engineassemblyimages = [
  { file: engcarb1, description: 'Carburetor assembled onto the engine.' },
  { file: engcarb2, description: 'Carburetor and linkage complete.' },
  { file: engmanifoldgasket, description: 'Intake-manifold gasket fitted.' },
  { file: engfuelpump, description: 'Fuel pump installed.' },
  { file: engclutchphoto, description: 'Centrifugal clutch mounted on the crankshaft.' }
];

const enginetestimages = [
  { file: engvidtest, description: 'The engine running as it came from the factory.' },
  { file: engvidclutch, description: 'The centrifugal clutch engaging.' },
  { file: engvidexhaust, description: 'The exhaust fitted and running.' }
];

const finalassemblyimages = [
  { file: faStart, description: 'The bare chassis, ready for final assembly.' },
  { file: faKnuckles, description: 'Fitting the steering knuckles, floor pan, throttle cable and master cylinder.' },
  { file: faEngine, description: 'Installing the engine and the transmission axle with its sprocket.' },
  { file: faSteering, description: 'Adding the steering wheel, column and tie-rods, and the front wheels.' },
  { file: faClutch, description: 'Fitting the centrifugal clutch and running the chain to the sprocket.' },
  { file: faBrakes, description: 'Installing the brakes.' },
  { file: faTankSeat, description: 'Fitting the fuel tank and the seat.' },
  { file: faComplete, description: 'The fully assembled go-kart.' }
];

const resulttestimages = [
  { file: resulttestrun, description: 'Static test — running the engine and working the throttle to check everything functions, without driving it.' }
];

const resultdrivingimages = [
  { file: resultdriving, description: 'Driving the go-kart — steering, throttle and brakes all working together.' }
];

const chassisitemimages = [
  { file: carbonsteelplate2mm, description: '2mm Carbon Steel Plate' },
  { file: tuboacocarbonomeiopol2mm, description: '2mm Carbon Steel Tubing (Meio Pol)' }
];

const basicframecutimages = [
  { file: measuringprotractor, description: 'Using a protractor to define the elbow angle before cutting the tube.' },
  { file: pipeelbowcut, description: 'Elbow cut prepared so the tube can be closed and welded at the desired angle.' }
];

const basicframeouterrailimages = [
  { file: woodentemplate1, description: 'Wooden jig used to keep the first two tubes aligned before welding.' },
  { file: woodentemplate2, description: 'Second view of the same wooden template holding the side-rail pieces in position.' },
  { file: pipeelbowwelded, description: 'Tube elbow already welded after the cut was closed at the correct angle.' },
  { file: externalsidebar, description: 'Outer side bar fabricated from the first welded assemblies.' }
];

const basicframeinnerlayoutimages = [
  { file: internalsidebar, description: 'Inner side bar fabricated after the outer rails were already defined.' },
  { file: kartspiece, description: 'Front pieces and side members separated and positioned up to this stage of the build.' }
];

const basicframecrossbarimages = [
  { file: fishmouthjoint1, description: 'Fishmouth example showing the saddle cut profile on a round tube.' },
  { file: fishmouthjoint2, description: 'Second fishmouth reference showing how the contour follows the receiving tube.' },
  { file: fishmouthvideo, description: 'Cutting the fishmouth (boca de lobo) notch so the tube saddles onto the next one.' },
  { file: crossbaridea, description: 'Crossbar positioned between the outer rails before the final weld.' },
  { file: crossbar, description: 'Outer side bars connected by the transverse crossbar after fitting.' }
];

const basicframeinnerrailimages = [
  { file: internalsidebaridea, description: 'Initial positioning idea for the inner side bars after the outer rails were connected.' },
  { file: internalsidebarfishmouthjoint, description: 'Fishmouth joints made on the inner side bar ends to fit the crossbar.' },
  { file: internalsidebarwelded, description: 'Inner side bars welded to the same transverse crossbar.' }
];

const basicframeconnectorimages = [
  { file: sidebarconnector, description: 'Connector bars fabricated to link the outer and inner side rails.' },
  { file: weldedconnector, description: 'Connector piece already welded between the side rails.' },
  { file: sidebarweldedconnector, description: 'Side rails tied together after welding the connector bars.' },
  { file: sidebarconnectorresult1, description: 'Result of the connector welds linking the side rails - view 1.' },
  { file: sidebarconnectorresult2, description: 'Result of the connector welds linking the side rails - view 2.' }
];

const basicframereinforcementimages = [
  { file: sideplate, description: 'Rear side plates welded to support the future transmission axle bearing housings.' },
  { file: internalcrossbaridea, description: 'Internal crossbar positioning used to reinforce the center of the structure.' },
  { file: internalcrossbarresult, description: 'Internal crossbar welded between the inner side rails.' }
];

const basicframefrontimages = [
  { file: frontparttemplate, description: 'Front jig built out of plane to compensate for the larger rear wheel and rear bearing arrangement.' },
  { file: frontalpiecefixed, description: 'Front piece fixed in the template before joining it to the chassis.' },
  { file: frontalpiececonnector, description: 'Front connector with the correct elbow angle and fishmouth cut prepared for welding.' },
  { file: frontalpiececonnectorresult, description: 'Front section welded to the main frame through the connector pieces.' }
];

const basicframeresultimages = [
  { file: basicframeresult, description: 'Completed basic chassis frame after the first structural stage.' }
];

const floordesignimages = [
  { file: floormold, description: 'Cardboard template made to capture the exact shape of the floor pan.' },
  { file: floorcad, description: 'CAD drawing of the floor, prepared to be water-jet cut by a specialized shop.' }
];

const floorformingimages = [
  { file: bendinthefloor, description: 'Bending the side edges of the flat cut plate so it wraps onto the chassis.' },
  { file: floorresult, description: 'The formed floor panel after the edges were bent.' }
];

const floormountingimages = [
  { file: weldingfloorsupport, description: 'Welding the support tabs to the chassis to receive the floor pan.' },
  { file: weldingfloorsupportresult, description: 'Support tabs welded to the chassis.' },
  { file: floorwithsupport, description: 'Floor panel test-fitted on the welded supports before final fixing.' }
];

const enginemountimages = [
  { file: enginemountplaning, description: 'Planning the engine-mount pieces and measuring the cut angles with a protractor.' },
  { file: enginemountpieces, description: 'The engine-support rails after being cut and profiled to shape.' },
  { file: enginemountstarting, description: 'Positioning the support rails across the rear of the frame to set where the engine would sit.' },
  { file: enginemountwelding, description: 'The engine-mount cradle welded to the chassis, with bolt holes for fixing the engine.' }
];

const seatsupportimages = [
  { file: seatsupportstart, description: 'Bending the first base tubes of the seat support to shape on a wooden template.' },
  { file: seatsupportengine, description: 'Routing the support tubes around the engine so the structure clears it without contact.' },
  { file: seatsupportwelding, description: 'Welding the seat-support tubes together onto the chassis.' },
  { file: seatsupportstructure, description: 'Building up the full tubular cage that holds the seat.' },
  { file: seatsupportfinal, description: 'The finished and primed seat-support frame.' },
  { file: seatsupportresult, description: 'The fiberglass seat mounted on the completed support.' }
];

const spindlesupportimages = [
  { file: spindlebuild, description: 'Fabricating and squaring up the steering-knuckle mounting bracket.' },
  { file: spindlebushings, description: 'King-pin bushings that let the steering knuckle pivot on its support.' },
  { file: spindlewelding1, description: 'Welding the knuckle support onto the chassis with the spindle mounted.' },
  { file: spindlewelding2, description: 'The knuckle support welded at the front corner of the chassis.' },
  { file: spindlefinal, description: 'Front end complete with both knuckles and the front wheels mounted.' }
];

const completedchassisimages = [
  { file: chassiscomplete1, description: 'The completed chassis — frame, floor mounts, engine cradle, seat cage and steering-knuckle supports all welded together.' },
  { file: chassiscomplete2, description: 'Top view of the finished frame with the cross members and mounting tabs, ready for the mechanical systems.' },
  { file: chassivideo, description: 'A walkaround of the finished chassis.' }
];

const paintingimages = [
  { file: paintprepprime, description: 'Cleaning and preparing the frame before priming.' },
  { file: paintapplyprime, description: 'Applying primer to the bare metal to protect it against rust.' },
  { file: paintprepdetails, description: 'Masking and preparing the frame for the detail paint.' },
  { file: paintchassi, description: 'Spraying the base color onto the chassis.' },
  { file: paintchassi2, description: 'Painting the chassis — second pass.' },
  { file: paintedchassi, description: 'The chassis after the base coat.' },
  { file: paintdetails, description: 'Painting the accent and detail colors.' },
  { file: paintdetails2, description: 'Detail painting — continued.' },
  { file: paintdetails3, description: 'Detail painting — finishing touches.' },
  { file: paintfinalresult, description: 'The final painted result.' }
];

const fueltankitemimages = [
  { file: fuelfilter, description: 'Fuel Filter' },
  { file: fuelhose, description: 'Fuel Hose' },
  { file: vacuumpump, description: 'Vacuum Pump' }
];

const steeringitemimages = [
  { file: bearing_steering, description: 'Bearing (Steering)' },
  { file: rodendsandsteeringrod, description: 'Rod Ends and Steering Rod' },
  { file: spindle, description: 'Spindle' },
  { file: steeringcolumnbearinghousing, description: 'Steering Column Bearing Housing' },
  { file: steeringwheel, description: 'Steering Wheel' },
  { file: steeringwheelhub, description: 'Steering Wheel Hub' }
];

const throttleitemimages = [
  { file: cablehousing_throttle, description: 'Cable Housing (Throttle)' },
  { file: pedals_throttle, description: 'Pedals (Throttle)' },
  { file: returnspring_throttle, description: 'Return Spring (Throttle)' },
  { file: steelbrakeandthrottlecable_throttle, description: 'Steel Brake and Throttle Cable' }
];

const pedalbaseimages = [
  { file: throttlepedalssupport, description: 'Pedal pivot tubes and return-spring bars welded to the front of the chassis.' }
];

const acceleratorpedalimages = [
  { file: throttlepedals, description: 'Accelerator pedal on its pivot tube, with the return spring and the throttle cable connected.' }
];

const transmissionitemimages = [
  { file: chain428h120, description: '428H Chain - 120 Links' },
  { file: bearinghousings_transmission, description: 'Bearing Housings (Transmission)' },
  { file: centrifugalclutch, description: 'Centrifugal Clutch' },
  { file: sprocketandsprockethub, description: 'Sprocket and Sprocket Hub' },
  { file: transmissionshaft30mm1m, description: 'Transmission Shaft 30mm - 1 Meter' },
  { file: wheelhub_transmission, description: 'Wheel Hub (Transmission)' }
];

// Work in progress: flip to false to show the full Go-Kart write-up once it's finished.
const GOKART_COMING_SOON = false;

export const GoKart = () => {
    if (GOKART_COMING_SOON) {
        return (
            <div>
                <TypingText content='Coming Soon.' />
            </div>
        );
    }

    return (

        <div className='content'>

            <GlowingText2em content='Go Kart'/>
            <p className='projecttext'>
                A go-kart is a small, low-profile vehicle typically used in motorsport or as a recreational machine. Despite their compact size, go-karts are capable of high performance and agility, making them an ideal platform for learning fundamental vehicle dynamics, mechanical engineering, and fabrication skills.
                A go-kart project involves the full design and construction of a vehicle from the ground up. This includes structural engineering (chassis), powertrain integration (engine and transmission), steering and suspension design, and the development of braking and safety systems. In addition to technical knowledge, such a project demands planning, creativity, and a hands-on approach to problem-solving.
            </p>

            <p className='projecttext'>
                This project, Go-Kart, was conceived as a challenge not only to build a functional go-kart, but also to explore and understand each mechanical system involved in real-world applications. Through the process, various tools and technologies were employed — ranging from CAD design in SolidWorks to physical prototyping and testing.
            </p>

            <div className="subtext">
                <GlowingText1em content=' Tools Used'/>
            </div>

            <div className="projecttext">
              <ul>
                <li>
                  The construction of a go-kart involves various stages: from designing and cutting the metal frame to welding, assembling mechanical parts, and finishing the structure. Each step requires specific tools to ensure precision, safety, and durability. Below is a detailed list of tools used throughout the project, along with their importance and function in the fabrication and assembly process.
                  <ul style={{ margin: '0px 40px' }}>
                    <li><b>Gasless MIG Welding Machine</b> is used to join metal parts of the go-kart, especially in the construction of the chassis. This type of welder operates without the need for external gas, using flux-core wire instead, which simplifies setup and makes it suitable for outdoor use.</li>
                    <li><b>80 Grit Zirconia Flap Disc</b> is ideal for grinding and finishing welds on the metal frame. Its zirconia grains provide aggressive material removal while maintaining durability.</li>
                    <li><b>Cutting Disc</b> is mounted on the angle grinder and used to cut metal components, such as steel tubes and brackets, to the required dimensions.</li>
                    <li><b>Grinding Disc</b> is also used with an angle grinder for cleaning up rough welds and smoothing sharp metal edges after cutting or welding.</li>
                    <li><b>Angle Grinder</b> is one of the most versatile tools in the build process, used with different discs (cutting, grinding, flap) for shaping, cutting, and finishing metal parts.</li>
                    <li><b>Angle Grinder Wire Brush</b> attachment is used to clean rust or paint from metal surfaces before welding, ensuring a clean and solid weld.</li>
                    <li><b>Anti-Spatter Spray</b> is applied to metal surfaces around weld joints to prevent molten metal from sticking during welding, which helps in post-weld cleanup.</li>
                    <li><b>Magnetic Square</b> helps hold metal parts at fixed angles (commonly 90° or 45°) during welding, ensuring precise alignment and consistent welds.</li>
                    <li><b>Caliper</b> is used to take precise measurements of components like axle diameters or spacer lengths, critical for ensuring alignment and fit during assembly.</li>
                    <li><b>Drill</b> is essential for making holes in metal parts for mounting components such as the seat, engine brackets, and steering system.</li>
                    <li><b>Drill Bits</b> of various sizes are used with the drill to match the bolt and screw requirements for different go-kart components.</li>
                    <li><b>Step Drill</b> is useful when making holes of various diameters in sheet metal, especially for creating clean holes in brackets or panels.</li>
                    <li><b>Rotary Burr</b> (or burr bit) is used in deburring and smoothing internal surfaces or edges after drilling or cutting, especially on welded joints.</li>
                    <li><b>Wire Brush</b> (manual) helps clean surfaces or remove slag, rust, or debris from tight spots or delicate areas that cannot be accessed with power tools.</li>
                    <li><b>Tube Bender</b> is used to shape steel tubing for the go-kart's chassis or protective structures, allowing for smooth curves without collapsing the tube.</li>
                    <li><b>Locking Pliers</b> (Vise-Grip) are essential for holding pieces in place during welding or adjustments, acting as a temporary clamp.</li>
                    <li><b>Bench Vise</b> provides a stable clamping surface for cutting, grinding, or assembling smaller parts of the go-kart.</li>
                    <li><b>C-Clamp</b> is another essential clamping tool to hold materials together during welding or drilling operations.</li>
                    <li><b>Measuring Tape</b> is used throughout the project for taking general measurements — frame length, axle placement, component spacing, etc.</li>
                    <li><b>MIG Wire Spool</b> is the consumable used by the MIG welder. The wire is continuously fed during welding and is crucial for maintaining weld quality.</li>
                    <li><b>Graphite Grease</b> is applied to moving parts such as bearings, steering linkages, and axle assemblies to reduce friction and protect against wear.</li>
                    <li><b>White and Black Paint</b> is used in the finishing stage to coat the metal frame and parts of the go-kart, protecting them from rust and giving a professional look.</li>
                    <li><b>Toolkit</b> contains a variety of essential hand tools like wrenches, screwdrivers, and sockets needed for assembling and maintaining the go-kart.</li>
                    <li><b>Prime</b> (Primer) is applied before painting to improve paint adhesion and protect the bare metal surface from corrosion.</li>
                  </ul>
                </li>
              </ul>
            </div>

            <Gallery images={toolimages} imageStyle={GALLERY_IMAGE_STYLE} alt="Tool" />

            <div className="subtext">
                <GlowingText1em content='⚠ PPE'/>
            </div>

            <div className='projecttext'>
              <ul>
                  <li>
                      <b>Personal Protective Equipment (PPE)</b> plays a fundamental role in ensuring the safety of individuals involved in any mechanical or fabrication project. When building a go-kart, exposure to high temperatures, rotating tools, sharp metal edges, and loud noises makes the proper use of PPE essential to avoid injuries and long-term health risks. Below is a list of PPE items used in the project and their respective functions:
                      <ul style={{ margin: '0px 40px' }}>
                          <li>
                              <b>Safety glasses</b> protect the eyes from metal shavings, dust, and sparks generated during cutting, grinding, or welding processes.
                          </li>
                          <li>
                              <b>Earmuffs</b> help reduce the risk of hearing loss by protecting against the loud noise levels produced by power tools and machinery.
                          </li>
                          <li>
                              <b>Welding gloves</b> provide heat resistance and protect the hands from sparks, molten metal, and sharp edges during welding or handling metal components.
                          </li>
                          <li>
                              <b>Welding helmet</b> is essential for protecting the face and eyes from the intense brightness and ultraviolet radiation produced during welding, as well as from flying debris.
                          </li>
                      </ul>
                  </li>
              </ul>
            </div>

            <Gallery images={ppeimages} imageStyle={GALLERY_IMAGE_STYLE} alt="PPE" />

            <div className="subtext">
                <GlowingText1em content='Building'/>
            </div>

            <div className='projecttext'>
                <b>Chassis:</b>
                <p className='projecttext'>
                  The chassis is the structural foundation of the go-kart. It serves as the main support frame to which all other components are mounted, including the seat, engine, wheels, and steering system. A strong and well-designed chassis ensures stability, safety, and balanced weight distribution during high-speed maneuvers.
                </p>
            </div>

            <div className='projecttext'>
              <ul>
                <li>
                  <b>Chassis</b> is the structural base of the go-kart, designed to support all major components and ensure mechanical integrity during operation.
                  <ul style={{ margin: '0px 40px' }}>
                    <li><b>2mm Carbon Steel Plate</b> is used to fabricate mounting surfaces and reinforcement elements for strength and durability.</li>
                    <li><b>2mm Carbon Steel Tubing (Meio Pol)</b> provides the framework for the chassis, balancing strength, weldability, and weight.</li>
                  </ul>
                </li>
              </ul>
            </div>

            <Gallery images={chassisitemimages} imageStyle={GALLERY_IMAGE_STYLE} alt="Chassis item" />

            <div className="subtext">
                <GlowingText1em content='Basic Frame'/>
            </div>

            <div className='projecttext'>
              The first chassis subsection was the fabrication of the basic frame. This stage defined the width of the go-kart, the relative position of the side rails, the first transverse connections, and the reference geometry that would later support the steering, transmission, and front structure. At this stage the work was done more like fixture-based fabrication than simple welding: parts were first measured, then tack welded, checked again, and only after the geometry looked correct were the final welds completed.
            </div>

            <div className='projecttext'>
              The main PPE used throughout the whole process was safety glasses, earmuffs, welding gloves, and a welding helmet. These were necessary because the work alternated between cutting, grinding, fitting, tack welding, and final welding. Another important detail in almost every stage was the finishing sequence after the welds: first a steel wire brush was used to clean residues and loose scale, then a grinding disc was used to remove excess material, and finally a flap disc was applied to leave a smoother and more uniform finish.
            </div>

            <div className='projecttext'>
              <b>1. Measuring the elbows and making the first cuts.</b> The process started by using a protractor to define the 90-degree elbow geometry needed for the first curved sections of the side rails. This step was important not only to create the bend itself, but also to make sure both sides of the chassis would start from the same reference. After the angle was marked, the elbow was cut so the tube could later be closed and welded with as little gap as possible, which helps both fit-up and weld quality.
            </div>

            <Gallery images={basicframecutimages} imageStyle={GALLERY_IMAGE_STYLE} alt="Basic frame elbow cutting" />

            <div className='projecttext'>
              <b>2. Using a wooden jig to weld the first outer rails.</b> After the elbow cut was prepared, a simple wooden template was used as a positioning jig so two tubes could be held at the correct angle before welding. This kind of improvised fixture is useful because it helps repeat the same geometry on both sides and makes tack welding safer and more controlled. Once the alignment was confirmed, the elbow joint was welded and cleaned, leading to the first complete outer side bar of the go-kart.
            </div>

            <Gallery images={basicframeouterrailimages} imageStyle={GALLERY_IMAGE_STYLE} alt="Outer rail construction" />

            <div className='projecttext'>
              <b>3. Defining the inner side bars and the first front pieces.</b> With the external side bars already established, the next step was to fabricate the internal side bars. This was the moment when the frame started to gain a real sense of width and internal structure. Right after that, the front pieces were also prepared and positioned, which made it easier to visualize the overall chassis layout up to that point and to anticipate how the front end would be integrated later.
            </div>

            <Gallery images={basicframeinnerlayoutimages} imageStyle={GALLERY_IMAGE_STYLE} alt="Inner rail and front-piece preparation" />

            <div className='projecttext'>
              <b>4. Preparing the fishmouth joints and fitting the first transverse crossbar.</b> To connect round tubes properly, fishmouth cuts were made on the ends of the crossbar that would join the external side rails. A practical way to make a fishmouth template for a desired angle is to first define the angle between the two tubes, then use the diameter of the receiving tube as reference. Next, wrap a paper or cardboard strip around that tube, trace the contour, transfer that contour to the tube being cut, and finally refine the profile with a grinder or rotary burr until the fit sits tight with minimal gap. Only after that fitting process was the crossbar positioned and welded between the outer rails.
            </div>

            <Gallery images={basicframecrossbarimages} imageStyle={GALLERY_IMAGE_STYLE} alt="Fishmouth and outer crossbar" />

            <div className='projecttext'>
              <b>5. Welding the inner side bars to the same cross member.</b> Once the outer rails were tied together, the internal rails could be positioned with much better reference. Their ends received fishmouth cuts so they could meet the transverse bar correctly, without large gaps or forced contact. After checking the spacing and symmetry, these internal bars were welded, giving the frame a much more coherent central structure and making the next reinforcement steps easier to execute.
            </div>

            <Gallery images={basicframeinnerrailimages} imageStyle={GALLERY_IMAGE_STYLE} alt="Inner side rail welding" />

            <div className='projecttext'>
              <b>6. Connecting the outer and inner rails with short structural links.</b> After both sets of side bars were in place, connector bars were fabricated to link the outer rails to the inner rails. These smaller members may look simple, but they are important because they reduce local flexibility and make the side assembly behave more like a rigid structural unit instead of isolated parallel tubes. After welding these connectors, the side structure became considerably stiffer and more resistant to torsion.
            </div>

            <Gallery images={basicframeconnectorimages} imageStyle={GALLERY_IMAGE_STYLE} alt="Side connector welding" />

            <div className='projecttext'>
              <b>7. Adding axle-support plates and reinforcing the middle of the frame.</b> With the lateral structure already tied together, two plates were welded at the rear upper portion of the side bars. These plates would later support the bearing housings for the transmission axle, so their placement already had to respect the future drivetrain alignment. After that, a transverse internal bar was added between the inner rails to further strengthen the structure and reduce flex in the central section of the chassis.
            </div>

            <Gallery images={basicframereinforcementimages} imageStyle={GALLERY_IMAGE_STYLE} alt="Reinforcement and side-plate" />

            <div className='projecttext'>
              <b>8. Building the front jig and welding the front section.</b> The front part required a dedicated template because it had to leave the original plane of the frame. This offset compensated for the larger rear wheel and the rear bearing-housing arrangement, allowing the chassis to evolve with the correct overall geometry. Once the front piece was fixed in the jig, connector pieces were made for each side with the correct elbow angle and fishmouth profile, and only then was the front section welded to the already assembled basic frame.
            </div>

            <Gallery images={basicframefrontimages} imageStyle={GALLERY_IMAGE_STYLE} alt="Front-section jig and welding" />

            <div className='projecttext'>
              <b>9. Result of the first chassis stage.</b> At the end of this phase, the go-kart already had a coherent basic structure: outer rails, inner rails, transverse members, rear support plates, and the front section all connected. This basic frame became the geometric reference for the following phases of the chassis construction and provided a solid foundation for the remaining mechanical systems.
            </div>

            <Gallery images={basicframeresultimages} imageStyle={GALLERY_IMAGE_STYLE} alt="Final basic-frame result" />

            <div className="subtext">
                <GlowingText1em content='Floor'/>
            </div>

            <div className='projecttext'>
                <b>1. Template and cutting.</b> The floor pan started from a cardboard template used to capture the exact shape needed. That shape was then drawn in CAD so the plate could be water-jet cut by a specialized company.
            </div>

            <Gallery images={floordesignimages} imageStyle={GALLERY_IMAGE_STYLE} alt="Floor template and cutting" />

            <div className='projecttext'>
                <b>2. Forming the panel.</b> With the flat piece in hand, the side edges were bent so the panel would wrap and seat onto the chassis, resulting in the formed floor.
            </div>

            <Gallery images={floorformingimages} imageStyle={GALLERY_IMAGE_STYLE} alt="Floor forming" />

            <div className='projecttext'>
                <b>3. Welding the supports and fixing.</b> Support tabs were welded to the chassis to receive the panel, and the floor was test-fitted on these welded supports. Finally, the floor was drilled together with the supports and fixed with M6 bolts and nuts.
            </div>

            <Gallery images={floormountingimages} imageStyle={GALLERY_IMAGE_STYLE} alt="Floor mounting" />

            <div className="subtext">
                <GlowingText1em content='Engine Mount'/>
            </div>

            <div className='projecttext'>
                The engine sits on a pair of fabricated steel mounts welded to the rear of the chassis. The layout was planned first and the cut angles measured with a protractor, then the support rails were cut and profiled to shape. With the rails positioned across the rear of the frame to set the engine's location, the mounting cradle was welded to the chassis, and bolt holes were left for fixing the engine.
            </div>

            <Gallery images={enginemountimages} imageStyle={GALLERY_IMAGE_STYLE} alt="Engine mount" />

            <div className="subtext">
                <GlowingText1em content='Seat Support'/>
            </div>

            <div className='projecttext'>
                The seat is carried by a tubular cage welded to the rear of the chassis. It started with the base tubes bent to shape on a wooden template, routed carefully so the structure would clear the engine without touching it. The tubes were then welded together, building up the full cage that holds the seat back and base. Once the structure was finished and primed, the fiberglass seat was mounted on it.
            </div>

            <Gallery images={seatsupportimages} imageStyle={GALLERY_IMAGE_STYLE} alt="Seat support" />

            <div className="subtext">
                <GlowingText1em content='Spindle Support'/>
            </div>

            <div className='projecttext'>
                The steering knuckles (spindles) pivot on supports built at the front corners of the chassis. A mounting bracket was fabricated and squared up, using king-pin bushings to let the knuckle pivot freely. The support was then welded onto the front of the chassis with the spindle in place, and once both sides were done the front wheels could be mounted.
            </div>

            <Gallery images={spindlesupportimages} imageStyle={GALLERY_IMAGE_STYLE} alt="Spindle support" />

            <div className="subtext">
                <GlowingText1em content='Completed Chassis'/>
            </div>

            <div className='projecttext'>
                With every support welded in — floor mounts, engine cradle, seat cage and steering-knuckle brackets — the chassis structure was complete: a rigid tubular frame ready to receive the powertrain, controls and bodywork.
            </div>

            <Gallery images={completedchassisimages} imageStyle={GALLERY_IMAGE_STYLE} alt="Completed chassis" />

            <div className="subtext">
                <GlowingText1em content='Pedals (Accelerator / Brake)'/>
            </div>

            <div className='projecttext'>
                The pedals give the driver the two primary controls — throttle and brake — both foot-operated from the front of the chassis. They are built around a small set of bought-in parts: a steel inner cable that runs inside a protective cable housing to carry the movement, and a return spring for each pedal to bring it back to rest. These are the materials that link the pedals to the engine and to the brakes.
            </div>

            <Gallery images={throttleitemimages} imageStyle={GALLERY_IMAGE_STYLE} alt="Pedal control materials — cable and housing" />

            <div className='projecttext'>
                <b>Mounting.</b> Both foot pedals share the same mounting. Two tubes — one per pedal, long enough for the pedal base to slide onto — were welded to the front of the chassis to act as the pedal pivots, and a small bar was welded beside each one to anchor its return spring.
            </div>

            <Gallery images={pedalbaseimages} imageStyle={GALLERY_IMAGE_STYLE} alt="Pedal mounting" />

            <div className='projecttext'>
                <b>Accelerator (throttle).</b> The accelerator pedal pivots on its tube and is pulled back to rest by its return spring. Pressing it tensions the steel throttle cable — routed inside its protective housing — that runs to the engine and opens the carburetor, so pedal travel maps directly to engine power; releasing the pedal lets the spring snap the throttle back to idle. This pedal, cable and return spring make up the entire throttle system, so there was no separate linkage to build.
            </div>

            <Gallery images={acceleratorpedalimages} imageStyle={GALLERY_IMAGE_STYLE} alt="Accelerator pedal" />

            <div className='projecttext'>
                <b>Brake.</b> The brake pedal mounts the same way, on its own tube and return spring, and is linked by cable to the master cylinder that actuates the hydraulic brakes — the braking hardware itself is covered in the Braking System section below.
            </div>

            <div className="subtext">
                <GlowingText1em content='Transmission'/>
            </div>

            <div className='projecttext'>
                The transmission transfers engine power to the rear axle, propelling the go-kart forward. Most go-karts use a simple chain drive system with a clutch. Proper alignment and tension of the chain are critical for efficient power delivery and preventing mechanical failures during operation.
            </div>

            <div className='projecttext'>
              <ul>
                <li>
                  <b>Transmission System</b> transfers power from the engine to the rear wheels, determining torque and speed output.
                  <ul style={{ margin: '0px 40px' }}>
                    <li><b>428H Chain - 120 Links</b> connects the engine sprocket to the axle sprocket to transmit rotational motion.</li>
                    <li><b>Bearing Housings (Transmission)</b> hold and align the rotating shaft while allowing it to spin freely.</li>
                    <li><b>Centrifugal Clutch</b> automatically engages and disengages power transfer based on engine speed.</li>
                    <li><b>Sprocket and Sprocket Hub</b> are gear-like components that drive or are driven by the chain to transfer torque.</li>
                    <li><b>Transmission Shaft 30mm - 1 Meter</b> transmits torque from the clutch to the wheels, serving as the main axle.</li>
                    <li><b>Wheel Hub (Transmission)</b> connects the axle shaft to the wheels, ensuring firm and centered mounting.</li>
                  </ul>
                </li>
              </ul>
            </div>

            <Gallery images={transmissionitemimages} imageStyle={GALLERY_IMAGE_STYLE} alt="Transmission item" />

            <div className='projecttext'>
                Unlike the other systems, the transmission needed no custom fabrication — it was simply assembled. The sprocket, rear brake disc and wheel hubs slide onto the axle, which turns on two pillow-block bearings bolted to the axle supports welded to the rear of the chassis.
            </div>

            <Gallery images={transmissionbuildimages} imageStyle={GALLERY_IMAGE_STYLE} alt="Transmission axle assembly" />

            <div className="subtext">
                <GlowingText1em content='Fuel Tank'/>
            </div>

            <div className='projecttext'>
                The fuel tank stores the gasoline needed to power the engine. Its placement and secure mounting are important for safety and weight balance. In go-kart projects, compact and lightweight tanks are preferred to reduce bulk while ensuring adequate fuel capacity for racing or long runs.
            </div>

            <div className='projecttext'>
              <ul>
                <li>
                  <b>Fuel Tank System</b> delivers fuel from the reservoir to the engine while ensuring safety and minimizing fuel loss or contamination.
                  <ul style={{ margin: '0px 40px' }}>
                    <li><b>Fuel Filter</b> removes contaminants from the fuel before it reaches the engine, protecting components from wear and damage.</li>
                    <li><b>Fuel Hose</b> connects the tank to the engine, providing a sealed path for fuel flow.</li>
                    <li><b>Vacuum Pump</b> assists in fuel delivery and pressure stabilization within the system when mechanical pumping is insufficient.</li>
                  </ul>
                </li>
              </ul>
            </div>

            <Gallery images={fueltankitemimages} imageStyle={GALLERY_IMAGE_STYLE} alt="Fuel tank item" />

            <div className='projecttext'>
                The tank was mounted low on the go-kart, tucked under the steering column and held in place by its own welded brackets.
            </div>

            <Gallery images={fueltankbuildimages} imageStyle={GALLERY_IMAGE_STYLE} alt="Fuel tank mounted" />

            <div className="subtext">
                <GlowingText1em content='Steering'/>
            </div>

            <div className='projecttext'>
                The steering mechanism enables the driver to control the direction of the go-kart. It typically involves a steering wheel, tie-rods, and spindles connected to the front wheels. Precision in the steering assembly is crucial for maneuverability, turning accuracy, and overall handling.
            </div>

            <div className='projecttext'>
              <ul>
                <li>
                  <b>Steering System</b> components enable the driver to control the direction of the go-kart with precision and stability.
                  <ul style={{ margin: '0px 40px' }}>
                    <li><b>Bearing (Steering)</b> reduces friction and ensures smooth rotation of the steering column or components.</li>
                    <li><b>Rod Ends and Steering Rod</b> connect and transmit motion from the steering column to the spindles.</li>
                    <li><b>Spindle</b> attaches to the wheel hub and rotates to change the wheel’s direction.</li>
                    <li><b>Steering Column Bearing Housing</b> supports the column while maintaining alignment and reducing vibration.</li>
                    <li><b>Steering Wheel</b> is the driver interface for applying directional input to the system.</li>
                    <li><b>Steering Wheel Hub</b> connects the steering wheel to the column, often with a quick-release feature.</li>
                  </ul>
                </li>
              </ul>
            </div>

            <Gallery images={steeringitemimages} imageStyle={GALLERY_IMAGE_STYLE} alt="Steering item" />

            <div className='projecttext'>
                <b>Steering knuckle:</b> Each front wheel turns on a steering knuckle built from three welded parts — a central tube, a rear plate, and the wheel axle stub — assembled and then mounted so it can swivel freely on its support.
            </div>

            <div className='projecttext'>
                <b>Central part.</b> The central part was modelled in SolidWorks — a 1-inch tube with a 2 mm wall, faced top and bottom to seat two bearings and bored 21 mm through the middle to take the machined axle stub and weld to it.
            </div>

            <Gallery images={steeringknucklepartimages} imageStyle={GALLERY_IMAGE_STYLE} alt="Steering knuckle central part" />

            <div className='projecttext'>
                <b>Rear part.</b> The rear part is a plate cut to the standard profile, carrying the holes that anchor the steering bar (tie-rod) to the knuckle.
            </div>

            <Gallery images={steeringknucklerearimages} imageStyle={GALLERY_IMAGE_STYLE} alt="Steering knuckle rear plate" />

            <div className='projecttext'>
                <b>Wheel axle.</b> The wheel axle stub was turned down on the lathe from a ready-made piece so it would seat into the bore of the central part and weld to it; the wheel then spins on this stub.
            </div>

            <Gallery images={steeringknuckleaxleimages} imageStyle={GALLERY_IMAGE_STYLE} alt="Steering knuckle wheel axle" />

            <div className='projecttext'>
                <b>Assembly &amp; result.</b> The three pieces were TIG-welded together and the bearings pressed in. On its support the knuckle stacks up as bolt and washer, then the top of the support, a spacer, the knuckle, another spacer, and finally the bottom washer and nut — so it swivels freely.
            </div>

            <Gallery images={steeringknuckleassemblyimages} imageStyle={GALLERY_IMAGE_STYLE} alt="Steering knuckle assembly and result" />

            <div className='projecttext'>
                <b>Steering-bar support:</b> a bracket, also drawn up in SolidWorks, that anchors the steering bars (tie-rods) running out from the column to each knuckle.
            </div>

            <Gallery images={steeringbarsupportimages} imageStyle={GALLERY_IMAGE_STYLE} alt="Steering-bar support" />

            <div className='projecttext'>
                <b>Steering column &amp; its support:</b> the column is a bar with two holes at the top for the steering-wheel hub. Near the bottom, two plates with a hole between them hold a uniball bearing, kept apart by two internal spacers — the same trick used on the knuckles. An M8 bolt is welded to the very end, in line with the bar, to anchor it. That bolt drops into the column support, a piece much like the knuckle central part but holding just two bearings that carry the column, clamped by the bolt and nut.
            </div>

            <Gallery images={steeringcolumnimages} imageStyle={GALLERY_IMAGE_STYLE} alt="Steering column and support" />

            <div className='projecttext'>
                <b>Fitting the support to the chassis.</b> With the column and its support built, the support was welded onto the chassis and finished, locating the steering column in its final position on the go-kart.
            </div>

            <Gallery images={steeringcolumnsupportimages} imageStyle={GALLERY_IMAGE_STYLE} alt="Column support welded to the chassis" />

            <div className='projecttext'>
                With the knuckles, column and supports all in place, the steering was assembled and checked end to end.
            </div>

            <Gallery images={steeringfinishedimages} imageStyle={GALLERY_IMAGE_STYLE} alt="Finished steering" />

            <div className="subtext">
                <GlowingText1em content='Braking System'/>
            </div>

            <div className='projecttext'>
                The braking system allows the driver to safely slow down or stop the go-kart. It usually consists of a mechanical or hydraulic disc brake mounted on the rear axle.
            </div>

            <div className='projecttext'>
              <ul>
                <li>
                  <b>Braking System</b> components are essential for providing control and safety during operation. A reliable braking system ensures the go-kart can decelerate or stop effectively, especially during high-speed maneuvers.
                  <ul style={{ margin: '0px 40px' }}>
                    <li><b>Brake Disc and Brake Disc Hub</b> form the interface where the caliper applies force to stop the wheel’s rotation.</li>
                    <li><b>Brake Hose</b> transports hydraulic fluid from the master cylinder to the calipers.</li>
                    <li><b>Cable Housing (Brakes)</b> encases the brake cables to allow smooth and protected movement of the inner wire.</li>
                    <li><b>DOT 4 Brake Fluid</b> transmits force from the brake pedal to the calipers in hydraulic brake systems.</li>
                    <li><b>Master Cylinder</b> generates hydraulic pressure in response to pedal force to actuate the brakes.</li>
                    <li><b>Pedals (Brakes)</b> serve as the user interface to initiate braking manually.</li>
                    <li><b>Return Spring (Brakes)</b> ensures the brake pedal returns to its initial position after being pressed.</li>
                    <li><b>Steel Brake and Throttle Cable</b> transfers mechanical motion efficiently and precisely between components.</li>
                    <li><b>Titan 150 Brake Calipers</b> clamp the brake disc using hydraulic pressure to generate stopping power.</li>
                  </ul>
                </li>
              </ul>
            </div>

            <Gallery images={brakingsystemitemimages} imageStyle={GALLERY_IMAGE_STYLE} alt="Braking system item" />

            <div className='projecttext'>
                <b>Building the brake:</b> The rear disc brake runs a Titan 150 motorcycle caliper, so it needed a custom mount. A template was first taken from the caliper and traced onto steel plate, which was then cut to the matching profile. The mount is built from two side plates that sandwich the main plate carrying the caliper — all drilled at two points for M12 bolts — and a 1-inch half-circle was ground into the base so it would seat cleanly and be welded onto the chassis tube. Two threads were tapped so the caliper bolts straight on.
            </div>

            <Gallery images={brakecaliperbuildimages} imageStyle={GALLERY_IMAGE_STYLE} alt="Brake caliper mount fabrication" />

            <div className='projecttext'>
                <b>Fitting the mount.</b> With the caliper bolted to its mount, the whole assembly was offered up to the disc and tacked onto the chassis — welding it assembled was the trick to line the pads up squarely with the disc.
            </div>

            <Gallery images={brakemountimages} imageStyle={GALLERY_IMAGE_STYLE} alt="Fitting the brake mount" />

            <div className='projecttext'>
                <b>Adjusting before the final weld.</b> Before locking everything down with the definitive welds, the caliper was adjusted so the pads met the disc squarely and the pad-to-disc contact was fine-tuned, checking that the brake bit cleanly. Only once it was working right was the mount welded up for good.
            </div>

            <Gallery images={brakeadjustimages} imageStyle={GALLERY_IMAGE_STYLE} alt="Adjusting the brake before the final weld" />

            <div className='projecttext'>
                <b>Master cylinder:</b> The master cylinder sits on its own removable plate — it bolts to a small plate held by four welded tabs, so the whole cylinder can be unbolted whenever needed. It is driven by a lever fixed vertically to the plate but free to pivot: the lower third of the lever connects to the master-cylinder pushrod while the upper two-thirds is pulled by the brake cable, so the leverage multiplies the pedal force going into the cylinder.
            </div>

            <Gallery images={mastercylinderbuildimages} imageStyle={GALLERY_IMAGE_STYLE} alt="Master cylinder" />

            <div className="subtext">
                <GlowingText1em content='Painting'/>
            </div>

            <div className='projecttext'>
                The painting phase gives the go-kart its final aesthetic appearance and protects the metal surfaces from rust and corrosion. Before painting, the frame is cleaned and primed.
            </div>

            <Gallery images={paintingimages} imageStyle={GALLERY_IMAGE_STYLE} alt="Painting" />

            <div className="subtext">
                <GlowingText1em content='Assembly'/>
            </div>

            <div className='projecttext'>
                With the chassis and every system built, final assembly brought it all together — starting with the engine.
            </div>

            <div className='projecttext'>
                <b>Engine:</b> The go-kart is powered by a Z-MAX 15 HP single-cylinder 4-stroke engine. These are the main components that go on it.
            </div>

            <Gallery images={enginepartimages} imageStyle={GALLERY_IMAGE_STYLE} alt="Engine components" />

            <div className='projecttext'>
                The engine was prepped by fitting the carburetor and its linkage, sealing the intake manifold with a fresh gasket, mounting the fuel pump, and bolting the centrifugal clutch to the crankshaft.
            </div>

            <Gallery images={engineassemblyimages} imageStyle={GALLERY_IMAGE_STYLE} alt="Engine assembly" />

            <div className='projecttext'>
                A few clips of the engine and clutch running:
            </div>

            <Gallery images={enginetestimages} imageStyle={GALLERY_IMAGE_STYLE} alt="Engine running" />

            <div className='projecttext'>
                With the engine ready and every subsystem built, it all came together on the bare chassis. Piece by piece the go-kart took shape — first the steering knuckles, floor pan and pedal controls, then the engine and drivetrain, the steering and front wheels, the clutch and chain, the brakes, and finally the tank and seat — until it stood as a complete, drivable machine.
            </div>

            <Gallery images={finalassemblyimages} imageStyle={GALLERY_IMAGE_STYLE} alt="Final assembly" />

            <div className="subtext">
                <GlowingText1em content='Results'/>
            </div>

            <div className='projecttext'>
                After all the design, machining, welding and assembly, it was finally time for the moment that makes the whole project worth it: firing it up and seeing it run. The engine started, the throttle responded crisply, power ran smoothly through the clutch and chain to the rear axle, the steering was precise and the brakes pulled the go-kart down with confidence — every subsystem that had been built in isolation now working as one.
            </div>

            <div className='projecttext'>
                <b>First run.</b> Before taking it out on the road, the go-kart was run standing still — firing up the engine and working the throttle to confirm everything functioned: the engine, throttle linkage and drivetrain all responding as they should, with no one on board yet.
            </div>

            <Gallery images={resulttestimages} imageStyle={GALLERY_IMAGE_STYLE} alt="Static test run" />

            <div className='projecttext'>
                <b>Out on the road.</b> With the first test passed, it was time to really drive it — stable, responsive and genuinely fun. Watching something built from raw steel tubing and a pile of parts come alive and tear down the road never gets old.
            </div>

            <Gallery images={resultdrivingimages} imageStyle={GALLERY_IMAGE_STYLE} alt="Driving the go-kart" />

            <div className='projecttext'>
                More than a finished vehicle, this go-kart is the sum of everything it took to build it — chassis design, powertrain integration, steering geometry, hydraulic braking, fabrication and a lot of hands-on problem-solving — all proven out in the real world, at speed. Project complete. 🏁
            </div>

        </div>
    );
};
